module.exports = __webpack_public_path__ + "static/automate-your-operation2-56472a2fdcf5ca9ff292f372b06ef770.png";